import { FC, useCallback } from 'react';

import { InputMod } from '@enums';
import type { InputTextProps } from '@types';
import { cn, validateValueEqual } from '@utils';

import { BaseTextInput, FilledTextInput } from '.';

export const NumberTextInput: FC<InputTextProps> = ({ className, inputMod, ...props }) => {
  const isFilled = validateValueEqual(inputMod, InputMod.Filled);

  const disableNumberInputScroll = useCallback((e: React.WheelEvent<HTMLInputElement>) => {
    e.currentTarget.blur();
  }, []);

  const numberInputStyle =
    '[&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [-moz-appearance:textfield]';

  const numberProps = {
    ...props,
    onWheel: disableNumberInputScroll,
    className: cn(numberInputStyle, className),
  };

  return isFilled ? <FilledTextInput {...numberProps} inputMod={inputMod} /> : <BaseTextInput {...numberProps} />;
};
